'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'mug-saucer';
var width = 640;
var height = 512;
var aliases = ["coffee"];
var unicode = 'f0f4';
var svgPathData = 'M440 48l24 0 0 320-352 0 0-320 328 0zm40 176l0-176 24 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-24 0zm0 144l0-128 24 0c57.4 0 104-46.6 104-104s-46.6-104-104-104l-24 0-16 0-24 0L112 32 96 32l0 16 0 320 0 16 16 0 352 0 16 0 0-16zM8 464l-8 0 0 16 8 0 560 0 8 0 0-16-8 0L8 464z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugSaucer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;